module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Select survey"},"de":{"title":"Umfrage wählen"},"fr":{"title":"Sélectionner un sondage"},"it":{"title":"Seleziona sondaggio"}}')
  delete Component.options._Ctor
}
